<template>
  <BModal :model-value="modal" scrollable centered title="Checkin" @update:modelValue="updateModal" size="xl"> 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Maintenance</h5>
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BTabs content-class="mt-3" align="center" justified>
      <BTab title="Information">
          <div class="form-group">
            <label for="">Service Date</label>
            <BFormInput type="date" placeholder="Service Date" />
          </div>
          <div class="form-group">
            <BFormSelect v-model="selectedVehicle" :options="vehicleOptions">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select vehicle</BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div class="form-group">
            <BFormSelect v-model="selectedServiceStatus" :options="serviceStatusOptions">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select service status</BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div class="form-group">
            <BFormSelect v-model="selectedDriver" :options="driverOptions">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select driver</BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div class="form-group">
            <BFormSelect v-model="selectedPaymentStatus" :options="paymentStatusOptions">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select payment status</BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
      </BTab>
      <BTab title="Items">
        <BForm>
          <BRow v-for="item,index in serviceItems" :key="index">
            <BCol md="3">
                <div class="form-group">  
                  <BFormInput type="text" placeholder="Name" />
                </div>
            </BCol>
            <BCol md="3">
                <div class="form-group">  
                  <BFormInput type="number" placeholder="quantity" />
                </div>
            </BCol>
            <BCol md="3">
              <div class="form-group">
                <BFormInput type="text" placeholder="Unit" />
              </div>
            </BCol>
            <BCol md="3">
              <div class="form-group">
                <BFormInput type="number" placeholder="Price" />
              </div>
            </BCol>
          </BRow>
          <div class="cta mb-3">
            <BButton variant="danger" @click="deleteItemExtracharge" class="mr-2"><i class="fas fa-minus"></i></BButton>
            <BButton variant="success" @click="addItemExtracharge"><i class="fas fa-plus"></i></BButton>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0 ">Total Harga : <b class="font-weight-bold">{{ totalPrice }}</b></p>
          </div>
        </BForm>
      </BTab>
    </BTabs>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton variant="primary" @click="submitReservation"  class="mr-2">Save</BButton>
            <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
        </div>
    </template>
  </BModal>
</template>

<script>
import { ref, computed } from "vue";

import { 
  BRow, 
  BCol, 
  BForm, 
  BModal, 
  BTabs,
  BTab,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BButton,
 } from "bootstrap-vue-next";
import vehicleDummy from '@/dummy-data/vehicle';
import driverDummy from '@/dummy-data/driverGuide';

export default {
    props: {
        modal: Boolean,
    },
    name: 'CheckInForm',
    components: {
        BRow, 
        BCol,
        BForm,
        BTabs,
        BTab,
        BModal,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BButton,
    },
    
    emits: ["update:modal"],
    
    setup(props, {emit}){
      const selectedVehicle = ref(null)
      const vehicleOptions = ref(vehicleDummy.map(vehicle => ({
        value: vehicle.vehicle_name,
        text: vehicle.vehicle_name
      })))

      const selectedServiceStatus = ref(null)
      const serviceStatusOptions = ref([
        {
          text: 'Under Maintenance',
        },
        {
          text: 'Maintenance Completed',
        },
      ])

      const selectedDriver = ref(null)
      const driverOptions = ref(driverDummy.filter(driver => driver.position === 'Driver').map(driver => ({
        value: driver.name,
        text: driver.name
      })))

      const selectedPaymentStatus = ref(null)
      const paymentStatusOptions = ref([
        {
          text: 'Pending',
        },
        {
          text: 'Lunas',
        },
      ])
        const serviceItem = ref(
          {
            name: '',
            quantity: 0,
            unit: '',
            price: 0
          }
        )
        const serviceItems = ref([
          {
            ...serviceItem.value
          }
        ])
        const addItemExtracharge = () => {
          serviceItems.value.push({...serviceItem.value})
        }
        const deleteItemExtracharge = () => {
          if(serviceItems.value.length > 1){
            serviceItems.value.pop()
          }
        }

        const updateModal = (value) => {
          emit("update:modal", value); // Sync modal state with parent
        };

        const totalPrice = computed(() => {
          return serviceItems.value.reduce((sum, item) => {
            return sum + (item.price * item.quantity);
          }, 0);
        });

        return{
            updateModal,
            addItemExtracharge,
            deleteItemExtracharge,
            totalPrice,
            serviceItems,
            serviceItem,
            selectedVehicle,
            vehicleOptions,
            selectedServiceStatus,
            serviceStatusOptions,
            selectedDriver,
            driverOptions,
            selectedPaymentStatus,
            paymentStatusOptions
        }
    }

}
</script>

<style>

</style>